module.exports = __webpack_public_path__ + "static/vue-theme-agon-design-aab7e2f7f8fe857cb92ead9f7e55deec.jpg";